import { RouteConfig } from "vue-router";
import PageNotFound from "@/views/errors/PageNotFound.vue";
import BadRequest from "@/views/errors/BadRequest.vue";

const routes: Array<RouteConfig> = [
    {
        path: "/",
        name: "Home",
        component: () => import(/* webpackChunkName: "Home" */ "@/views/home/Index.vue")
    },
    {
        path: "/test",
        name: "Test",
        component: () => import(/* webpackChunkName: "Home" */ "@/views/Test.vue")
    },
    {
        path: "/registry",
        name: "Registry",
        meta: { title: "registry.title" },
        component: () => import(/* webpackChunkName: "registry" */ "@/views/Registry.vue")
    },
    {
        path: "/login",
        name: "Login",
        meta: { title: "login.title" },
        component: () => import(/* webpackChunkName: "login" */ "@/views/Login.vue")
    },
    {
        path: "/identity-login",
        name: "IdentityLogin",
        component: () => import(/* webpackChunkName: "login" */ "@/views/IdentityLogin.vue"),
        props: route => ({ ticket: route.query.ticket })
    },
    {
        path: "/terms",
        name: "Terms",
        meta: { title: "terms.title" },
        component: () => import(/* webpackChunkName: "terms" */ "@/views/Terms.vue")
    },
    {
        path: "/reset-password",
        name: "ResetPassword",
        meta: { title: "resetPassword.title2" },
        component: () => import(/* webpackChunkName: "reset-password" */ "@/views/ResetPassword.vue")
    },
    {
        path: "/plan/:planId(\\d+)",
        name: "PlanDetail",
        meta: { title: "plan.detailTitle" },
        component: () => import(/* webpackChunkName: "plan-detail" */ "@/views/plan/Detail.vue"),
        props: route => ({ planId: Number(route.params.planId) })
    },
    {
        path: "/plan/:planId(\\d+)/registration",
        name: "Registration",
        meta: { title: "registration.title" },
        component: () => import(/* webpackChunkName: "plan-detail" */ "@/views/plan/Registration.vue"),
        props: route => ({ planId: Number(route.params.planId) })
    },
    {
        path: "/plan/:planId(\\d+)/registration/info",
        name: "RegistrationInfo",
        meta: { title: "plan.registrationInfo" },
        component: () => import(/* webpackChunkName: "plan-detail" */ "@/views/plan/RegistrationInfoEdit.vue"),
        props: route => ({ planId: Number(route.params.planId), readOnly: route.query.readOnly === "true" })
    },
    {
        path: "/my",
        name: "My",
        meta: { title: "common.title.default" },
        component: () => import(/* webpackChunkName: "enrollment-detail" */ "@/views/my/My.vue")
    },
    {
        path: "/my/info",
        name: "Info",
        meta: { title: "my.info.title", parentPath: "/my" },
        component: () => import(/* webpackChunkName: "enrollment-detail" */ "@/views/my/info/MyInfo.vue")
    },
    {
        path: "/my/info/basic-info",
        name: "BasicInfo",
        meta: { title: "common.base.basicInfo" },
        component: () => import(/* webpackChunkName: "enrollment-detail" */ "@/views/my/info/BasicInfoEdit.vue")
    },
    {
        path: "/my/info/identity",
        name: "IdentityInfo",
        meta: { title: "common.base.basicInfo" },
        component: () => import(/* webpackChunkName: "enrollment-detail" */ "@/views/my/info/IdentityInfoEdit.vue")
    },
    {
        path: "/my/language",
        name: "Language",
        meta: { title: "my.language.title", parentPath: "/my" },
        component: () => import(/* webpackChunkName: "enrollment-detail" */ "@/views/my/Language.vue")
    },
    {
        path: "/my/plans",
        name: "MyPlans",
        meta: { title: "my.myRegistration", parentPath: "/my" },
        component: () => import(/* webpackChunkName: "enrollment-detail" */ "@/views/my/MyPlans.vue")
    },
    {
        path: "/my/plans/:planId(\\d+)/detail",
        name: "MyPlanDetail",
        meta: { title: "my.myRegistration" },
        component: () => import(/* webpackChunkName: "enrollment-detail" */ "@/views/plan/Registration.vue"),
        props: route => ({ planId: Number(route.params.planId) })
    },
    {
        path: "/my/plans/:planId(\\d+)/upload",
        name: "MyPlanUpload",
        meta: { title: "my.myRegistrationUpload" },
        component: () => import(/* webpackChunkName: "enrollment-detail" */ "@/views/my/MyPlanUpload.vue"),
        props: route => ({ planId: Number(route.params.planId) })
    },
    {
        path: "/my/classes",
        name: "MyClasses",
        meta: { title: "my.myClasses", parentPath: "/my" },
        component: () => import(/* webpackChunkName: "enrollment-detail" */ "@/views/my/MyClasses.vue")
    },
    {
        path: "/my/certificates",
        name: "MyCertificates",
        meta: { title: "my.myCertificates", parentPath: "/my" },
        component: () => import(/* webpackChunkName: "enrollment-detail" */ "@/views/my/MyCertificates.vue")
    },
    {
        path: "/my/classes/:classId(\\d+)/detail",
        name: "MyClassesDetail",
        meta: { title: "my.class.title", parentPath: "/my/classes" },
        component: () => import(/* webpackChunkName: "enrollment-detail" */ "@/views/my/MyClassesDetail.vue"),
        props: route => ({ classId: Number(route.params.classId) })
    },
    {
        path: "/404",
        name: "404",
        meta: { title: "common.title.default" },
        component: () => import(/* webpackChunkName: "enrollment-detail" */ "@/views/errors/PageNotFound.vue")
    },
    {
        path: "/tcm/search",
        name: "TcmSearch",
        component: () => import(/* webpackChunkName: "Home" */ "@/views/home/tmc/Search.vue"),
        props: route => ({ keyWord: route.query.q, sortKey: route.query.sort })
    }
];
routes.push({
    path: "/bad-request",
    component: BadRequest
});
routes.push({
    path: "*",
    component: PageNotFound
});

export default routes;
